import { isProdHost } from './host';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Fire window.fbq('track', eventName, params, { eventID }) if fbq is
 * loaded AND the current page hostname is in the prod-host allowlist.
 *
 * The host gate is defense-in-depth on top of the Webflow site-wide
 * fbq guard (added 2026-06-20). Without it, any non-prod origin that
 * still loads a stale fbq snippet would emit Meta Lead/Schedule events
 * to prod's pixel — exactly the Jun 3 → Jun 19 staging leak.
 *
 * Wraps the actual call in try/catch because a third-party fbq stub
 * from an extension can throw and we must never block the host page.
 */
export function trackFbq(
  eventName: string,
  params: Record<string, unknown>,
  eventId: string,
  prodHosts?: string[]
): void {
  try {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
    if (!isProdHost(prodHosts)) return;
    window.fbq('track', eventName, params, { eventID: eventId });
  } catch {
    /* analytics best-effort */
  }
}
